import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import Home from '../components/Home'
import Vendas from '../modules/Vendas/Vendas'
import Compras from '../modules/Compras/Compras'
import AprovacaoDescontoOsOrcamento from '../modules/AprovacaoDescontoOsOrcamento/Index'
import DetalheOrcamento from '../modules/AprovacaoDescontoOsOrcamento/DetalheOrcamento/DetalheOrcamento'

import AprovacaoPedidoCompra from '../modules/AprovacaoPedidoCompra/Index'
import DetalhePedidoCompra   from '../modules/AprovacaoPedidoCompra/DetalhePedidoCompra/DetalhePedidoCompra'
import AprovacaoDescontoEquipamento from '../modules/AprovacaoDescontoEquipamento'


import LiberaProximaVenda from '../modules/LiberaProximaVenda'
import LiberacoesFinanceiras from '../modules/LiberacoesFinanceiras'

const RoutesAuthenticated = () => {

  return (
    
    <Routes>
      {/* <Route path="/login" element={<Login />} /> */}
      {/* <Route path="*" element={<Navigate to="/home" />} /> */}
      <Route path="/" element={<Home />} />

      <Route path="/aprovacao_desconto_os_orcamento" element={<AprovacaoDescontoOsOrcamento />} />
      <Route path="/aprovacao_desconto_os_orcamento_detalhe" element={<DetalheOrcamento />} />

      <Route path="/aprovacao_pedido_compra" element={<AprovacaoPedidoCompra />} />
      <Route path="/aprovacao_pedido_compra_detalhe" element={<DetalhePedidoCompra />} />

      <Route path="/aprovacao_desconto_equipamento" element={<AprovacaoDescontoEquipamento />} />

      <Route path="/libera_proxima_venda" element={<LiberaProximaVenda />} />
      <Route path="/liberacoes_financeiras" element={<LiberacoesFinanceiras />} />

      <Route path="*" element={<Navigate to="/" />} />

    </Routes>
  )

}

export default RoutesAuthenticated
